import { render, staticRenderFns } from "./FiltroStatusPagamento.vue?vue&type=template&id=67bef3f4&"
import script from "./FiltroStatusPagamento.vue?vue&type=script&lang=js&"
export * from "./FiltroStatusPagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports